module.exports = __webpack_public_path__ + "static/media/logo-dark-en.8b16f751.svg";